import BaseError from 'services/error-handler-service/base-error';

export class HTTPError extends BaseError {
  constructor(message, httpStatus, ...params) {
    super(...params);
    this.message = message;
    this.httpStatus = httpStatus;
    this.name = this.httpStatus > 499 ? 'ServerError' : 'ClientError';
  }
}

//  property exceptions
export class PropertyError extends BaseError {
  constructor(message, property, ...params) {
    super(...params);
    this.message = message;
    this.name = 'PropertyError';
    this.property = property;
  }
}

// exceptions for homeroom features
export class FeatureError extends BaseError {
  constructor(message, feature, ...params) {
    super(...params);
    this.message = message;
    this.name = 'FeatureError';
    this.feature = feature;
  }
}
